import { render } from "./debug.vue?vue&type=template&id=d4a7d2d4"
import script from "./debug.vue?vue&type=script&lang=js"
export * from "./debug.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__